module.exports = __webpack_public_path__ + "img/2020.10.d650da84.png";